import React, { useEffect, useState } from 'react';
import styles from './AwardQualification.module.scss';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../../redux/hooks';
import dropdownArrowLight from '../../../../assets/images/LightTheme/down_arrow_light.svg';
import dropdownArrowDark from '../../../../assets/images/DarkTheme/down_arrow_dark.svg';
import { map } from 'lodash';
import { formatDatetoLong } from '../../../../utils/common';
import { useGetAwardHistoryQuery } from '../../../../redux/services/awardHistoryAPI';
import { useProfileParams } from '../../../../utils/common';
import { getAwardNameFromCode } from '../../../../utils/awardIconMapping';
import ErrorInPageScreen from '../../../common/ErrorInPageScreen/ErrorInPageScreen';
import { getTrackingStatusNameFromCode } from '../../../../utils/awardIconMapping';

const AwardQualification = () => {
  const { t } = useTranslation();
  const currentTheme = useAppSelector((state: any) => state.theme.currentTheme);
  const dropdownArrow = currentTheme === 'light' ? dropdownArrowLight : dropdownArrowDark;
  const [isContentVisible, setIsContentVisible] = useState<boolean>(false);
  const [isAPIError, setIsAPIError] = useState(false);

  const { affiliateCode, aboNumber } = useProfileParams();

  const handleDropdownClick = () => {
    setIsContentVisible((prevState) => !prevState);
  };

  const { data: AwardHistoryResponse, isError } = useGetAwardHistoryQuery(
    {
      affiliateCode,
      aboNumber,
    },
    {
      skip: isAPIError,
      refetchOnMountOrArgChange: true,
    }
  );

  const handleAPIError = () => {
    setIsAPIError(true);
  };
  useEffect(() => {
    isError && handleAPIError();
  }, [isError]);

  const closingMonthFormatted = AwardHistoryResponse?.body?.closingMonth
    ? `${AwardHistoryResponse?.body?.closingMonth.slice(-2)}/${AwardHistoryResponse?.body?.closingMonth.slice(0, 4)}`
    : '-';

  const getFormattedYear = (year: number | null) => (year ? `${t('py')} ${year}` : '-');
  const highestAwardInMarket = AwardHistoryResponse?.body?.awardSummary?.inMarket?.highestAward;
  const highestAwardGar = AwardHistoryResponse?.body?.awardSummary?.gar?.highestAward;

  return (
    <div className={`qualificaiton_info_wrapper ${styles.qualificaiton_info_wrapper}`}>
      <div
        className={styles.section_title_wraper}
        style={{
          borderBottom: !isContentVisible
            ? `1px solid ${currentTheme === 'light' ? '#E4E4E4' : '#282828'}`
            : '',
        }}
      >
        <label
          className={`content_inner_label ${styles.section_label}`}
          data-testid="contact_card_section_heading_testID"
        >
          <div className={styles.main_label}>{t('qualification_journey')}</div>
        </label>
        <img
          src={dropdownArrow}
          alt="Dropdown Arrow"
          className={`dropdown_icon ${styles.dropdown_icon} ${isContentVisible ? styles.rotate : ''}`}
          onClick={handleDropdownClick}
          style={{
            cursor: true ? 'pointer' : 'default',
          }}
        />
      </div>
      {isContentVisible && (
        <div className={`qualification_main_wrapper ${styles.qualification_main_wrapper}`}>
          {isAPIError ? (
            <ErrorInPageScreen
              handleClickTryAgain={() => {
                setIsAPIError(false);
              }}
            />
          ) : (
            <div className={styles.inner_wrapper}>
              <div className={styles.entry_date_wrapper}>
                <span className={styles.item_key}>{t('entry_date')}:</span>
                {formatDatetoLong(AwardHistoryResponse?.body?.awardSummary?.entryDate)}
                {/* <div className={styles.milstone_item}>
                    <span className={styles.item_key}>{t("primary_market")}:</span>
                    {AwardHistoryResponse?.body?.awardSummary?.primaryMarket ? AwardHistoryResponse?.body?.awardSummary?.primaryMarket : "-"}
                  </div> */}
              </div>
              <div className={styles.table_wrapper}>
                <div className={`award_tbl_wrapper ${styles.award_tbl_wrapper}`}>
                  <div className={styles.milstone_row}>
                    <span className={styles.item_key}>{t('highest_in_market')}:</span>
                    <span className={styles.award_year}>
                      {getFormattedYear(highestAwardInMarket?.firstAchievedPerformanceYear)}
                    </span>
                    <span>
                      {highestAwardInMarket?.awardCode
                        ? getAwardNameFromCode(highestAwardInMarket?.awardCode, t) || '-'
                        : '-'}
                    </span>
                  </div>
                  <table className={styles.award_table}>
                    <thead className={styles.tbl_head_wrapper}>
                      <tr className={`tbl_head ${styles.tbl_head}`}>
                        <th>{t('award_milstone')}</th>
                        <th>{t('first_time_qualification')}</th>
                      </tr>
                    </thead>
                    <tbody className={`tbl_body ${styles.tbl_body}`}>
                      {map(AwardHistoryResponse?.body?.awardMilestone, (row, index: any) => (
                        <tr
                          key={index}
                          className={`tbl_row ${styles.tbl_row} ${index % 2 === 0 ? `even_row ${styles.even_row}` : `odd_row ${styles.odd_row}`}`}
                        >
                          <td>
                            {row?.awardCode ? getAwardNameFromCode(row?.awardCode, t) || '-' : '-'}
                          </td>
                          <td>{getFormattedYear(row?.firstAchievedPerformanceYear)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div className={`award_tbl_wrapper ${styles.award_tbl_wrapper}`}>
                  <div className={styles.milstone_row}>
                    <span className={styles.item_key}>{t('gar_highest')}:</span>
                    <span className={styles.award_year}>
                      {getFormattedYear(highestAwardGar?.firstAchievedPerformanceYear)}
                    </span>
                    <span>
                      {highestAwardGar?.awardCode
                        ? getAwardNameFromCode(highestAwardGar?.awardCode, t) || '-'
                        : '-'}
                    </span>
                  </div>

                  <table className={`${styles.award_table} ${styles.three_col_tbl}`}>
                    <thead className={styles.tbl_head_wrapper}>
                      <tr className={`tbl_head ${styles.tbl_head}`}>
                        <th>{t('Year')}</th>
                        <th>{t('in_market')}</th>
                        <th>{t('gar')}</th>
                      </tr>
                    </thead>
                    <tbody className={`tbl_body ${styles.tbl_body}`}>
                      {AwardHistoryResponse?.body?.highestAwardHistory?.inMarket?.map(
                        (inMarketAward: any, index: any) => {
                          const garAward =
                            AwardHistoryResponse?.body?.highestAwardHistory?.gar?.[index];
                          return (
                            <tr
                              key={index}
                              className={`tbl_row ${styles.tbl_row} ${index % 2 === 0 ? `even_row ${styles.even_row}` : `odd_row ${styles.odd_row}`}`}
                            >
                              <td>{getFormattedYear(inMarketAward?.performanceYear)}</td>
                              <td>
                                <div className={styles.award_name_container}>
                                  {inMarketAward?.awardCode
                                    ? getAwardNameFromCode(inMarketAward?.awardCode, t) || '-'
                                    : '-'}
                                  {inMarketAward?.trackingStatusCode ? (
                                    <span className={`tracking_tag ${styles.tracking_tag}`}>
                                      {getTrackingStatusNameFromCode(
                                        inMarketAward?.trackingStatusCode,
                                        t
                                      )}
                                    </span>
                                  ) : (
                                    ''
                                  )}
                                </div>
                              </td>
                              <td>
                                <div className={styles.award_name_container}>
                                  {garAward?.awardCode
                                    ? getAwardNameFromCode(garAward?.awardCode, t) || '-'
                                    : '-'}
                                  {garAward?.trackingStatusCode ? (
                                    <span className={`tracking_tag ${styles.tracking_tag}`}>
                                      {getTrackingStatusNameFromCode(
                                        garAward?.trackingStatusCode,
                                        t
                                      )}
                                    </span>
                                  ) : (
                                    ''
                                  )}
                                </div>
                              </td>
                            </tr>
                          );
                        }
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AwardQualification;
